import { apiService } from './api';
import { API_CONFIG } from '../config/api';

export interface ReleaseNote {
  id: number;
  version: string;
  title: string;
  description: string;
  releaseDate: string;
  features?: string[];
  bugFixes?: string[];
}

/**
 * Fetches the latest release notes from the backend.
 * Returns null if the call fails or no notes are available.
 */
export const getLatestReleaseNotes = async (): Promise<ReleaseNote | null> => {
  try {
    const response = await apiService.request<ReleaseNote>(
      API_CONFIG.ENDPOINTS.GET_RELEASE_NOTES,
      { method: 'GET' }
    );

    if (response.success && response.data) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.warn('Error fetching release notes:', error);
    return null;
  }
};

const STORAGE_KEY = 'releaseNotes_lastDismissedId';

/**
 * Check if the release note has already been dismissed by the user.
 */
export const isReleaseNoteDismissed = (noteId: number): boolean => {
  const dismissedId = localStorage.getItem(STORAGE_KEY);
  return dismissedId === String(noteId);
};

/**
 * Mark a release note as dismissed so it won't show again.
 */
export const dismissReleaseNote = (noteId: number): void => {
  localStorage.setItem(STORAGE_KEY, String(noteId));
};

/**
 * Check if a release note is within the 48-hour display window.
 */
export const isWithin48Hours = (releaseDate: string): boolean => {
  const release = new Date(releaseDate).getTime();
  const now = Date.now();
  const FORTY_EIGHT_HOURS = 48 * 60 * 60 * 1000;
  return (now - release) <= FORTY_EIGHT_HOURS;
};
